export default "__VITE_ASSET__BvwNEXLB__"